import InerteRegistreAdmissionController from './inerte.registre.admission.controller';

export default {
    template: require('./inerte.registre.admission.html'),
    controller: InerteRegistreAdmissionController
};
